import {
  type Canvas,
  type Control,
  controlsUtils,
  type FabricObject,
  type FabricObjectProps,
  type Point,
  Polygon,
  type TMat2D,
} from 'fabric';
import { hasKey } from '@witmetrics/utils/objects';
import { filterInKeyValue } from '@witmetrics/utils/arrays';

export function createPolygon(
  points: Point[],
  options: Partial<FabricObjectProps> = {}
): Polygon {
  return new Polygon(points, {
    ...options,
    fill: options.fill || 'hsla(180,20%,60%,0.5)',
    stroke: options.stroke || 'hsla(180,20%,60%,1)',
    strokeWidth: hasKey(options, 'strokeWidth') ? options.strokeWidth : 2,
  });
}

export function createCornerControls(): Record<
  'tl' | 'tr' | 'bl' | 'br',
  Control
> {
  let { tl, tr, bl, br } = controlsUtils.createObjectDefaultControls();
  return { tl, tr, bl, br };
}

export function getObjectsByName(
  fabricCanvas: Canvas,
  name: string
): FabricObject[] {
  return filterInKeyValue(fabricCanvas.getObjects(), 'name', name);
}

export function getObjectsByImageType(
  fabricCanvas: Canvas,
  imageType: string
): FabricObject[] {
  return filterInKeyValue(fabricCanvas.getObjects(), 'imageType', imageType);
}

export function findObjectByName(
  fabricCanvas: Canvas,
  name: string
): FabricObject | undefined {
  return getObjectsByName(fabricCanvas, name)[0];
}

export function findObjectByImageType(
  fabricCanvas: Canvas,
  imageType: string
): FabricObject | undefined {
  return getObjectsByImageType(fabricCanvas, imageType)[0];
}

export function parseTransform(
  transform?: TMat2D
): Record<'scale' | 'left' | 'top', number> {
  if (!transform) return { scale: 1, left: 0, top: 0 };
  return { scale: transform[0], left: transform[4], top: transform[5] };
}

export function cloneBoundingBox(obj1: FabricObject, obj2: FabricObject) {
  // Set the scale/position/angle of obj1 to match obj2
  obj1.scaleX = obj2.scaleX;
  obj1.scaleY = obj2.scaleY;
  obj1.left = obj2.left;
  obj1.top = obj2.top;
  obj1.angle = obj2.angle;
}
